export const Sharwama_items = [
  {
    id: 1,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003641/savory/sharwama1_ndmzqi.png',
    name: 'BBQ Chicken Sharwama',
    category: 'Sharwama',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 2,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003641/savory/sharwama2_cprk8k.png',
    name: 'BBQ Chicken Sharwama',
    category: 'Sharwama',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 3,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003644/savory/sharwama3_czdvcy.png',
    name: 'BBQ Chicken Sharwama',
    category: 'Sharwama',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 4,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003641/savory/sharwama4_xientg.png',
    name: 'BBQ Chicken Sharwama',
    category: 'Sharwama',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 5,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003643/savory/sharwama5_w3clwl.png',
    name: 'BBQ Chicken Sharwama',
    category: 'Sharwama',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 6,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003643/savory/sharwama6_pkjwlo.png',
    name: 'BBQ Chicken Sharwama',
    category: 'Sharwama',
    desc: '',
    price: 1300,
    quantity: 1,
  },

  {
    id: 7,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003642/savory/sharwama7_dmhthy.png',
    name: 'Couple Pack',
    category: 'Sharwama',
    desc: 'Two Sharwama|One 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 8,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003642/savory/sharwama7_dmhthy.png',
    name: 'Family Pack',
    category: 'Sharwama',
    desc: 'Two Sharwama|Two mini-warma|Two 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 9,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003642/savory/sharwama7_dmhthy.png',
    name: 'Couple Pack',
    category: 'Sharwama',
    desc: 'Two Sharwama|One 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 10,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003642/savory/sharwama7_dmhthy.png',
    name: 'Family Pack',
    category: 'Sharwama',
    desc: 'Two Sharwama|Two mini-warma|Two 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 11,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003642/savory/sharwama7_dmhthy.png',
    name: 'Couple Pack',
    category: 'Sharwama',
    desc: 'Two Sharwama|One 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 12,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003642/savory/sharwama7_dmhthy.png',
    name: 'Couple Pack',
    category: 'Sharwama',
    desc: 'Two Sharwama|One 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
];

export const Grills_items = [
  {
    id: 1,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668074549/savory/grill_img1_nqtff5.png',
    name: 'Chicken Thigh            ',
    category: 'Grills',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 2,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668074549/savory/grill_img2_cxcac8.png',
    name: 'Chicken Breast in sticks',
    category: 'Grills',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 3,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668075102/savory/grill_img3_pqsszb.png',
    name: 'Ckicken wing and sauce',
    category: 'Grills',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 4,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668075102/savory/grill_img4_bybsrp.png',
    name: 'Whole Grilled Chicken',
    category: 'Grills',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 5,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668074549/savory/grill_img5_idrhwx.png',
    name: 'Honey Dipped Chicken Thigh',
    category: 'Grills',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 6,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668074551/savory/grill_img6_fgvrdp.png',
    name: 'Spicy Chicken Kebab',
    category: 'Grills',
    desc: '',
    price: 1300,
    quantity: 1,
  },

  {
    id: 7,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668075197/savory/grill_img7_xq1li1.png',
    name: 'Chips',
    category: 'Grills',
    desc: 'Small Portion',
    price: 3000,
    quantity: 1,
  },
  {
    id: 8,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668075198/savory/grill_img8_gs5hkl.png',
    name: 'Family Pack',
    category: 'Grills',
    desc: 'Two Sharwama|Two mini-warma|Two 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 9,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668074551/savory/grill_img9_ickhf9.png',
    name: 'Couple Pack',
    category: 'Grills',
    desc: 'Two Sharwama|One 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 10,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668074551/savory/grill_img10_wjx8yb.png',
    name: 'Family Pack',
    category: 'Grills',
    desc: 'Two Sharwama|Two mini-warma|Two 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 11,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668075285/savory/grill_img11_gb8zxw.png',
    name: 'Couple Pack',
    category: 'Grills',
    desc: 'Two Sharwama|One 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 12,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668075286/savory/grill_img12_pfmp7u.png',
    name: 'Couple Pack',
    category: 'Grills',
    desc: 'Two Sharwama|One 1LChivita  ',
    price: 3000,
    quantity: 1,
  },

  {
    id: 13,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668074549/savory/grill_img13_iak4lq.png',
    name: 'Family Pack',
    category: 'Grills',
    desc: 'Two Sharwama|Two mini-warma|Two 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 14,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668074549/savory/grill_img14_f8incs.png',
    name: 'Family Pack',
    category: 'Grills',
    desc: 'Two Sharwama|Two mini-warma|Two 1LChivita',
    price: 3000,
    quantity: 1,
  },
];

export const Buger_items = [
  {
    id: 1,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003641/savory/sharwama1_ndmzqi.png',
    name: 'BBQ Chicken Sharwama',
    category: 'Sharwama',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 2,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003641/savory/sharwama2_cprk8k.png',
    name: 'BBQ Chicken Sharwama',
    category: 'Sharwama',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 3,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003644/savory/sharwama3_czdvcy.png',
    name: 'BBQ Chicken Sharwama',
    category: 'Sharwama',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 4,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003641/savory/sharwama4_xientg.png',
    name: 'BBQ Chicken Sharwama',
    category: 'Sharwama',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 5,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003643/savory/sharwama5_w3clwl.png',
    name: 'BBQ Chicken Sharwama',
    category: 'Sharwama',
    desc: '',
    price: 1300,
    quantity: 1,
  },
  {
    id: 6,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003643/savory/sharwama6_pkjwlo.png',
    name: 'BBQ Chicken Sharwama',
    category: 'Sharwama',
    desc: '',
    price: 1300,
    quantity: 1,
  },

  {
    id: 7,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003642/savory/sharwama7_dmhthy.png',
    name: 'Couple Pack',
    category: 'Sharwama',
    desc: 'Two Sharwama|One 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 8,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003642/savory/sharwama7_dmhthy.png',
    name: 'Family Pack',
    category: 'Sharwama',
    desc: 'Two Sharwama|Two mini-warma|Two 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 9,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003642/savory/sharwama7_dmhthy.png',
    name: 'Couple Pack',
    category: 'Sharwama',
    desc: 'Two Sharwama|One 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 10,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003642/savory/sharwama7_dmhthy.png',
    name: 'Family Pack',
    category: 'Sharwama',
    desc: 'Two Sharwama|Two mini-warma|Two 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 11,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003642/savory/sharwama7_dmhthy.png',
    name: 'Couple Pack',
    category: 'Sharwama',
    desc: 'Two Sharwama|One 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
  {
    id: 12,
    img: 'https://res.cloudinary.com/dmrdnero7/image/upload/v1668003642/savory/sharwama7_dmhthy.png',
    name: 'Couple Pack',
    category: 'Sharwama',
    desc: 'Two Sharwama|One 1LChivita  ',
    price: 3000,
    quantity: 1,
  },
];
